import React, { Component } from "react";
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import { connect } from "react-redux";

import { fetchCalendarEntriesForCompany } from "../../../actions/calendar-entries.js";
import { getRandomColor } from "../../../utils/colors.js";
// Css for calendar
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";

BigCalendar.momentLocalizer(moment);

class CompanyCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: "month",
      selectedDate: new Date(),
    };

    // userId: color
    this.userEventColor = {};
  }

  /**
   * Handle Calendar's slot select event
   */
  onCalendarSlotSelect = slotInfo => {
    // Check the difference between start & end
    // Go to day view if < 24hours and current view is not already day
    let start = moment(slotInfo.start);
    let end = moment(slotInfo.end);

    if ((end.diff(start, 'hours')) < 24 && (this.state.view !== 'day')) {
      this.setState({
        view: 'day',
        selectedDate: start.toDate()
      });
    } else if (end.diff(start, 'hours') >= 24 && (this.state.view !== 'week')) {
      // Go to week view if >= 24hours and current view is not already week
      this.setState({
        view: 'week',
        selectedDate: start.toDate()
      });
    }
  }

  componentDidMount() {
    this.props.fetchCalendarEntriesForCompany(this.props.user.company_id);
  }

  render() {
    const { companyEntries } = this.props;

    return (
      <div className="company-calendar" style={{ height: '100vh' }}>
        <BigCalendar
          defaultDate={this.state.selectedDate}
          date={this.state.selectedDate}
          onNavigate={(day) => this.setState({ selectedDate: new Date(day) })}
          events={companyEntries}
          views={['month', 'week', 'day']}
          view={this.state.view}
          startAccessor={(e) => new Date(e.start)}
          endAccessor={(e) => new Date(e.end)}
          titleAccessor={e => `${e.title} - ${e.user.first_name} ${e.user.last_name}`}
          min={moment().hour(7).minute(0).second(0).toDate()}
          max={moment().hour(23).minute(0).second(0).toDate()}
          onView={view => this.setState({ view })}
          onSelectSlot={this.onCalendarSlotSelect}
          eventPropGetter={(event, start, end, isSelected) => {
            if (!this.userEventColor[event.user.id]) {
              this.userEventColor[event.user.id] = getRandomColor();
            }
            return { style: { background: this.userEventColor[event.user.id] } }
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.currentUser,
    companyEntries: state.calendarEntry.company
  };
};

const mapDispatchToProps = {
  fetchCalendarEntriesForCompany
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyCalendar);



// WEBPACK FOOTER //
// ./src/components/main/calendar/_companyCalendar.js